import { ConfirmDialog } from "../../ui";

type DeleteEventDialogProps = {
  eventName: string;
  isOpen: boolean;
  onDelete: () => Promise<void>;
  onClose: (update?: boolean) => void;
};

/** Deleting an event: a thin wrapper round the kit's ConfirmDialog (errors are reported by the parent's toast). */
const DeleteEventDialog = (props: DeleteEventDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    onClose={(confirmed) => props.onClose(confirmed ? true : undefined)}
    onConfirm={props.onDelete}
    title="Delete Event"
    heading="Are you sure?"
    message={
      <>
        This action cannot be undone. Deleting <strong>{props.eventName}</strong> will un-assign all its tournaments and
        seasons and permanently remove the event.
      </>
    }
    confirmLabel="Delete"
    tone="danger"
  />
);

export default DeleteEventDialog;
